export enum ActiveTabs {
    generalSettings = 'General Settings',
    faq = 'FAQ',
    seo = 'SEO'
}